
    <template>
      <section class="content element-doc">
        <h2>TreeSelect 下拉树选择</h2>
<p>下拉树结构选择器</p>
<h3>基础用法</h3>
<p>apex-tree-select 的基础用法</p>
<demo-block>
        <div><p><code>data</code>属性为树形结构数据，设置<code>default-expand-all</code>属性默认展开树结构，<code>props</code>属性为配置选项（详细配置参考 <a href="https://element.eleme.cn/#/zh-CN/component/tree#props" target="_blank">element-ui 官网</a> 文档）</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-tree-select
  style=&quot;width:300px;&quot;
  v-model=&quot;val&quot;
  :data=&quot;data&quot;
  :props=&quot;props&quot;
  default-expand-all
  popper-append-to-body
  ref=&quot;treeSelect&quot;
&gt;&lt;/apex-tree-select&gt;

&lt;script&gt;
export default {
  name: &quot;home&quot;,
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: &quot;我的账户&quot;,
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: &quot;账户概览&quot;,
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: &quot;账户提现(账户信息)&quot;,
                }
              ]
            }
          ]
        },
        {
          title: &quot;公司&quot;,
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: &quot;部门&quot;,
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: &quot;小组&quot;
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>多选</h3>
<p>多选操作</p>
<demo-block>
        <div><p>设置<code>show-checkbox</code>属性开启多选模式。</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-tree-select
  style=&quot;width:300px;&quot;
  v-model=&quot;val&quot;
  :data=&quot;data&quot;
  :props=&quot;props&quot;
  show-checkbox
  default-expand-all
  popper-append-to-body
  ref=&quot;treeSelect&quot;
&gt;&lt;/apex-tree-select&gt;

&lt;script&gt;
export default {
  name: &quot;home&quot;,
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: &quot;我的账户&quot;,
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: &quot;账户概览&quot;,
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: &quot;账户提现(账户信息)&quot;,
                }
              ]
            }
          ]
        },
        {
          title: &quot;公司&quot;,
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: &quot;部门&quot;,
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: &quot;小组&quot;
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>搜索</h3>
<p>开启搜索节点功能</p>
<demo-block>
        <div><p>设置<code>filterable</code>属性开启开启搜索节点功能。</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-tree-select
  style=&quot;width:300px;&quot;
  v-model=&quot;val&quot;
  :data=&quot;data&quot;
  :props=&quot;props&quot;
  show-checkbox
  default-expand-all
  popper-append-to-body
  filterable
  ref=&quot;treeSelect&quot;
&gt;&lt;/apex-tree-select&gt;

&lt;script&gt;
export default {
  name: &quot;home&quot;,
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: &quot;我的账户&quot;,
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: &quot;账户概览&quot;,
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: &quot;账户提现(账户信息)&quot;,
                }
              ]
            }
          ]
        },
        {
          title: &quot;公司&quot;,
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: &quot;部门&quot;,
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: &quot;小组&quot;
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>父子节点不关联</h3>
<p>使父子节点不相关联</p>
<demo-block>
        <div><p>在显示复选框的情况下，设置<code>check-strictly</code>属性使父子节点不互相关联。设置<code>check-half</code>属性使选择子节点时自动勾选上它的所有父节点。</p>
</div>
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-tree-select
  style=&quot;width:300px;&quot;
  v-model=&quot;val&quot;
  check-strictly
  check-half
  :data=&quot;data&quot;
  :props=&quot;props&quot;
  show-checkbox
  default-expand-all
  popper-append-to-body
  ref=&quot;treeSelect&quot;
&gt;&lt;/apex-tree-select&gt;

&lt;script&gt;
export default {
  name: &quot;home&quot;,
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: &quot;我的账户&quot;,
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: &quot;账户概览&quot;,
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: &quot;账户提现(账户信息)&quot;,
                }
              ]
            }
          ]
        },
        {
          title: &quot;公司&quot;,
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: &quot;部门&quot;,
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: &quot;小组&quot;,
                  children: [
                    {
                      id: 4,
                      pid: 3,
                      title: &quot;成员&quot;
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>apex-tree-select Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>值 (可直接使用v-model双向绑定值)</td>
<td>—</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>clearable</td>
<td>是否显示清除icon</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>filterable</td>
<td>是否开启搜索模式</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>popper-append-to-body</td>
<td>是否将弹出层插入至body下</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>disabled</td>
<td>是否禁用</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>show-checkbox</td>
<td>是否开启多选模式</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>default-expand-all</td>
<td>是否默认展开所有树节点</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>check-strictly</td>
<td>在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>check-half</td>
<td>在设置checkStrictly模式下，设置此属性使所选择节点自动勾选上所有父节点</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>placeholder</td>
<td>placeholder占位符</td>
<td>string</td>
<td>—</td>
<td>请选择</td>
</tr>
<tr>
<td>size</td>
<td>组件大小</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>node-key</td>
<td>每个树节点用来作为唯一标识的属性，整棵树应该是唯一的</td>
<td>string</td>
<td>—</td>
<td>id</td>
</tr>
<tr>
<td>data</td>
<td>下拉树结构数据</td>
<td>array</td>
<td>—</td>
<td>[]</td>
</tr>
<tr>
<td>props</td>
<td>配置选项，具体看下表</td>
<td>object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>default-expanded-keys</td>
<td>默认展开的节点的 key 的数组</td>
<td>array</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>props</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>指定节点标签为节点对象的某个属性值</td>
<td>string, function(data, node)</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>children</td>
<td>指定子树为节点对象的某个属性值</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>disabled</td>
<td>指定节点选择框是否禁用为节点对象的某个属性值</td>
<td>boolean, function(data, node)</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>isLeaf</td>
<td>指定节点是否为叶子节点，仅在指定了 lazy 属性的情况下生效</td>
<td>boolean, function(data, node)</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-tree-select',{ref:"treeSelect",staticStyle:{"width":"300px"},attrs:{"data":_vm.data,"props":_vm.props,"default-expand-all":"","popper-append-to-body":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  name: "home",
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: "我的账户",
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: "账户概览",
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: "账户提现(账户信息)",
                }
              ]
            }
          ]
        },
        {
          title: "公司",
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: "部门",
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: "小组"
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-tree-select',{ref:"treeSelect",staticStyle:{"width":"300px"},attrs:{"data":_vm.data,"props":_vm.props,"show-checkbox":"","default-expand-all":"","popper-append-to-body":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  name: "home",
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: "我的账户",
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: "账户概览",
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: "账户提现(账户信息)",
                }
              ]
            }
          ]
        },
        {
          title: "公司",
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: "部门",
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: "小组"
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-tree-select',{ref:"treeSelect",staticStyle:{"width":"300px"},attrs:{"data":_vm.data,"props":_vm.props,"show-checkbox":"","default-expand-all":"","popper-append-to-body":"","filterable":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  name: "home",
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: "我的账户",
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: "账户概览",
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: "账户提现(账户信息)",
                }
              ]
            }
          ]
        },
        {
          title: "公司",
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: "部门",
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: "小组"
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-tree-select',{ref:"treeSelect",staticStyle:{"width":"300px"},attrs:{"check-strictly":"","check-half":"","data":_vm.data,"props":_vm.props,"show-checkbox":"","default-expand-all":"","popper-append-to-body":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  name: "home",
  data() {
    return {
      props: {
        label: 'title',
      },
      data: [
        {
          title: "我的账户",
          id: 869,
          pid: 868,
          children: [
            {
              id: 877,
              pid: 869,
              title: "账户概览",
              children: [
                {
                  id: 878,
                  pid: 877,
                  title: "账户提现(账户信息)",
                }
              ]
            }
          ]
        },
        {
          title: "公司",
          id: 1,
          pid: 0,
          children: [
            {
              id: 2,
              pid: 1,
              title: "部门",
              children: [
                {
                  id: 3,
                  pid: 2,
                  title: "小组",
                  children: [
                    {
                      id: 4,
                      pid: 3,
                      title: "成员"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      val: []
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  